import { UseSuspenseQueryOptions } from '@tanstack/react-query';
import { EnterpriseResourceParameters, ResourceResult, useRepositorySuspenseQuery } from '@mews-commander/data-access';

const defaultExtent = {
    resourceCategories: false,
    resourceCategoryAssignments: false,
    resourceFeatures: false,
    resourceFeatureAssignments: false,
    resources: false,
    slots: false,
} as const;

type UseResourcesGetAllQueryParams = Omit<EnterpriseResourceParameters, 'extent'> & {
    extent: Partial<EnterpriseResourceParameters['extent']>;
};

type Options<R> = Pick<UseSuspenseQueryOptions<ResourceResult, Error, R>, 'select'>;

export const useResourcesGetAllQuery = <R = ResourceResult>(
    params: UseResourcesGetAllQueryParams,
    options?: Options<R>
) =>
    useRepositorySuspenseQuery(
        'resources',
        'getAll',
        {
            ...params,
            extent: {
                ...defaultExtent,
                ...params.extent,
            },
        },
        options
    );
